import { Client, LeadInline, apiBase } from "@authoxi/ui-shared";

const client = new Client({ baseUrl: apiBase() });

/**
 * The design-partner ask.
 *
 * One field, and the source says which page it came from — a leads table that records only
 * "somebody arrived" answers nothing anyone would want to know.
 *
 * `POST /leads/request-access` is a route that **did not exist** for a while: this form posted
 * to it from the start, got a 404, and fell back to a `mailto:` the visitor may never have
 * sent. Silently, so nobody found out. Hence the visible failure state below — a form that
 * swallows its own error is how you lose the leads you were counting.
 */
export function Ask({ id, source }: { id: string; source: string }) {
  // `source` is the closed portfolio taxonomy — every landing page is `landing`. Which PAGE it
  // was goes in `surface`, the dimension that exists for exactly that. A per-page source would
  // make "which surface converts across the portfolio" unanswerable.
  //
  // No state here any more: the kit owns the field, the busy flag, the error and the "shown"
  // event, which is the whole point of there being one of it.
  return (
    <section className="section">
      <div className="page">
        <div className="ask">
          <div className="grid-bg" />
          <div style={{ position: "relative" }}>
            <p className="label">Design partners</p>
            <h2 className="xl" style={{ margin: "var(--s4) 0 var(--s3)" }}>
              Bring one agent.
            </h2>
            <p className="lede" style={{ margin: "0 auto" }}>
              Design partners get the gate, the signed evidence and a direct line to the people
              building it. One field — we will not make you fill in a form to find out what this
              costs.
            </p>

            {/* THE FORM IS THE KIT'S. This file owns the pitch, the route and the source —
                everything a product genuinely decides — and none of the field layout, busy
                state, error handling or event timing, which is where the gate rule lives.

                It was a second implementation of the same four fields, and this exact form once
                posted to a route that did not exist and fell back to a mailto nobody sent. */}
            <LeadInline
              transport={{
                submit: (body) =>
                  client.post<{ unsubscribe_url?: string }>("/leads/request-access", {
                    ...body,
                    surface: source,
                  }),
              }}
              product="authoxi"
              source="landing"
              subject={id}
              trigger="page"
              copy={{
                title: "Request access",
                body: "One email. Leave in one click. We never sell it.",
                cta: "Request access",
                done: "Thank you — we will write to you.",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
